export class HideMenu {
  public static readonly type = '[MenuDisplay] HideMenu';
}
